
<template>
	<section>			
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
			<!-- @keyup.enter.native="getReport" -->
				<el-form-item>
                 <el-select  v-model="State"  filterable  placeholder="选择评价状态" >
                  <el-option label="教练已评价" value="0"> </el-option>
                 <el-option label="教练未评价" value="1"> </el-option>
                 <el-option label="学员已评价" value="2"> </el-option>
                 <el-option label="学员未评价" value="3"> </el-option>
                 <el-option label="未评价" value="4"> </el-option>
                 <el-option label="评价已完成" value="5"> </el-option>
          
                 </el-select>   			
                </el-form-item>

 				<el-form-item >                 
                <el-select  v-model="TenancyId"  filterable placeholder="选择或搜索门店" @change="ChangeList"  >
                 <el-option
               v-for="item in optionsShop"
               :key="item.Id"
                  :label="item.Name"
               :value="item.Id">
                  </el-option>
                   </el-select>				 
                </el-form-item>  

				<el-form-item>
                <el-select  v-model="CoachId" clearable filterable  placeholder="请选择教练" >
                <el-option
                  v-for="item in options"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id">
               </el-option>
                 </el-select>
				</el-form-item>  

                <el-form-item >
                <el-date-picker
                    v-model="monthValueStart"
                    type="date"
                    placeholder="选择开始月份">
                </el-date-picker>
                </el-form-item>
               <el-form-item >
                <el-date-picker
                    v-model="monthValueEnd"
                    type="date"
                    placeholder="选择结束月份">
                </el-date-picker>
            </el-form-item>
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="getReport" icon="el-icon-search">查询</el-button>
					<!-- <el-button size="width:100%; height:100%;" type="warning" :loading="reportLoading" v-on:click="exportReport" icon="el-icon-search">导出总计</el-button>					 -->
				</el-form-item>		
			</el-form>
		</el-col>
		<!--列表-->
		<el-table   :data="coachList" highlight-current-row v-loading="listLoading"  style="width:1702px">
    <!-- <el-table-column type="expand">
      <template slot-scope="props">
          <el-table :data="props.row.ItemDimension"  >
          <el-table-column prop="Name" label="维度名称" width="120"  sortable>             
          </el-table-column>
			<el-table-column prop="Type" label="维度类型" width="120" :formatter="formatType" sortable>
			</el-table-column>          
           	<el-table-column prop="Value" label="维度值" width="120"  sortable>
			</el-table-column>	           
           	<el-table-column prop="EvaluateValue" label="评价值" width="120"  sortable>
			</el-table-column>
 			  <el-table-column prop="State" label="状态" width="120" >				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="success" size="medium" v-if="scope.row.State=='1'">已评价维度</el-tag>
                  <el-tag type="warning" size="medium" v-if="scope.row.State=='0'||scope.row.State==null">未评价维度</el-tag>
                  </div>
                  </template>
			</el-table-column>  			
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>            
          </el-table>
		  			<el-col :span="24" class="toolbar">
			<el-tag>当前有{{props.row.ItemDimension.length}}个维度</el-tag>
		    </el-col>
      </template>
    </el-table-column>                  -->
			<!-- <el-table-column type="selection" width="55">
			</el-table-column>		 -->
			<el-table-column prop="CoachName" label="教练名称" width="120" sortable>
			</el-table-column>
 			<el-table-column prop="ComboName" label="套餐名称" width="170"  sortable>
			</el-table-column>	           
			<el-table-column prop="ConsumptionTime" label="消费时间" width="200"  sortable>
			</el-table-column>	
			<el-table-column prop="BasicInformationName" label="会员名称" width="120" sortable>
			</el-table-column>	
			<el-table-column prop="CoachComment" label="教练评语" width="200"  sortable>
			</el-table-column> 
 			<el-table-column prop="CoachCommentTime" label="评价时间" width="200"  sortable>
			</el-table-column>              
 			<el-table-column prop="StudentComment" label="学员评语" width="200"  sortable>
			</el-table-column>
 			<el-table-column prop="StudentCommentTime" label="评价时间" width="200"  sortable>
			</el-table-column>                                     				
 			  <!-- <el-table-column prop="State" label="评价进度" width="120" >				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="warning" size="medium" v-if="scope.row.State=='2'">等待学员评价</el-tag>
                  <el-tag type="info" size="medium" v-if="scope.row.State=='0'">等待教练评价</el-tag>
                   <el-tag type="success" size="medium" v-if="scope.row.State=='3'">评价已完成</el-tag>
                  </div>
                  </template>
			</el-table-column>            -->
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
  			<el-table-column prop="StudentCommentTime" label="操作" width="170"   fixed="right">
                  	<template  slot-scope="scope">
					<el-button type="primary" size="small" @click="ShowItem(scope.$index, scope.row)">查看评价维度</el-button>
				</template>
			</el-table-column>            
		</el-table>
        		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-tag>当前有{{coachList.length}}个评价记录</el-tag>
		</el-col>

        <el-dialog title="新增" v-model="Visible" :close-on-click-modal="false">
          <el-table :data="ItemModel"  >
          <el-table-column prop="Name" label="维度名称" width="120"  sortable>             
          </el-table-column>
			<el-table-column prop="Type" label="维度类型" width="120" :formatter="formatType" sortable>
			</el-table-column>          
           	<el-table-column prop="Value" label="维度值" width="120"  sortable>
			</el-table-column>	           
           	<el-table-column prop="EvaluateValue" label="评价值" width="120"  sortable>
			</el-table-column>
 			  <el-table-column prop="State" label="状态" width="120" >				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="success" size="medium" v-if="scope.row.State=='1'">已评价维度</el-tag>
                  <el-tag type="warning" size="medium" v-if="scope.row.State=='0'||scope.row.State==null">未评价维度</el-tag>
                  </div>
                  </template>
			</el-table-column>  			
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>            
          </el-table>
		</el-dialog>
		<!--工具条-->
         <!-- <template slot-scope="scope"> -->
		<!-- <el-col  :span="24" class="toolbar" v-for="item  in studentList" :key="item.Month">
            <el-table show-summary  :summary-method="studentGetSummaries" :data="item.StudentList"  highlight-current-row v-loading="listLoading"  style="width:1702px"  >
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" width="80" >
			</el-table-column>
            <el-table-column prop="Month" label="培训月份" width="150" sortable>
			</el-table-column>     
			<el-table-column prop="CardNumber" label="会员卡号" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Name" label="姓名" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Phone" label="电话" width="150" sortable>
			</el-table-column>
       
			<el-table-column prop="Count" label="培训次数" min-width="150" sortable>
			</el-table-column>
		</el-table>
         
		</el-col> -->
           <!-- </template> -->
         
		</section>
</template>

<script>
	import util from '../../common/js/util'
import {mapGetters} from 'vuex';
	//import NProgress from 'nprogress'
	import {getEvaluateItem, getCoachOptionsList,getEvaluateReport ,ExportReportDetail,ExportReport,getShopInfor} from '../../api/api';

	export default {
		data() {
			return {
                ItemModel:[],
                Visible:false,
                State:'',
                TenancyId:'',
                optionsShop:[],
				filters: {
					Name: ''
                },
                items:[
                   { message: 'Foo' },
                    { message: 'Bar' }
                ],
                CoachId:'',
                monthValueStart:'',
                monthValueEnd:'',
				Count:0,
				options:[],
                coachList:[],
                Members:[],
                studentList:[],
				listLoading: false,
				reportLoading:false,
			}
		},
		methods: {
            ShowItem(index,row){
                console.log(row);
               this.Visible=true;
                this.ShowItemDate(row);
            },
            ShowItemDate(row){
                
				let para = {
					Id: row.Id,					
				};
				getEvaluateItem(para).then((res) => {                
                     this.ItemModel=res.data;
				})
				 .catch(error=>{
                 alert('网络错误');
                });                
            },
         formatType: function (row, column) {
				return row.Type == 1 ? '学员考察维度' :  '教练考察维度' ;
			},     
         open(value)
            {
               console.log(value);

            },
         ChangeList()
         {
             console.log('1');
              this.getCoachList();           
         },   
	           ...mapGetters(['getuserstate']),
			formatDate: function (row, column) {
				return util.formatDate.format(new Date(row.Birthday), 'yyyy-MM-dd');
			},

			getReport() {

                if(this.CoachId=='')
                {
                    			this.$message({
									message: '请选择教练',
									type: 'error'
                                });
                                return;
                }

                if(this.monthValueStart=='')
                {
                    			this.$message({
									message: '请选择开始月份',
									type: 'error'
                                });
                                return;
                }
                 if(this.monthValueEnd=='')
                {
                    			this.$message({
									message: '请选结束月份',
									type: 'error'
                                });
                                return;
                }               
				let para = {
					CoachId: this.CoachId,					
					monthValueStart:this.monthValueStart,
                    monthValueEnd:this.monthValueEnd,
                    TenancyId:this.TenancyId,
                    CoachId:this.CoachId,
                    State:this.State
				};
				this.listLoading = true;
				getEvaluateReport(para).then((res) => {
                 
                     this.coachList=res.data;
                    //  this.studentList=res.data.Data.StudentReportList;
                                        //   console.log(res.data.Data.CoachReportList);
                                        //   console.log(res.data.Data.StudentReportList);
					// this.total = res.data.TotleCount;
					// this.Members =res.data.Data;
                    // this.Count=res.data.TotleCount;
					this.listLoading = false;
				})
				 .catch(error=>{
                 alert('网络错误');
                });
            },		
            
            getCoachList()
            {
                let para={
                    TenancyId:this.TenancyId
                }
            getCoachOptionsList(para).then((res)=>{
					//  console.log(res);
              this.options=res.data;
				 }).catch(error=>{
             }) 
            },
          getShopList()
           {
            let para={}
            getShopInfor(para).then((res) => {                  
                    this.optionsShop = res.data;
                    // console.log( this.optionsShop);
				})
				 .catch(error=>{
                 alert('网络错误');
                });          				
           },               

		},
		mounted() {
            // this.getCoachList();
            // this.TenancyId=JSON.parse(this.getuserstate()).TenancyId;
            this.getShopList();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
	.el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}

</style>


// WEBPACK FOOTER //
// EvaluateDimension.vue?22c38d2b